export const useSubmit = (url, urlAfterSubmit, options) => {
  const router = useRouter();

  const {
    afterSubmit: iAfterSubmit = null,
    withNotification = true,
    withWarning = true,
    shouldThrow = false,
  } = options || {};

  const { Message, Notification } = useNotification();

  const pending = ref(false);

  const afterSubmit =
    iAfterSubmit ||
    (() => {
      if (urlAfterSubmit) {
        router.push(urlAfterSubmit);
      }
    });

  const handleSubmit = async (value, t = (v) => v) => {
    pending.value = true;
    try {
      const res = await $fetch(url, {
        method: "post",
        body: value,
      });
      if (res.message && res.code !== 0) {
        if (withNotification || withWarning) {
          Notification.warning({ title: res.message });
        }
      } else {
        if (withNotification) {
          Message.success({ title: t(res.message || "操作成功") });
        }
        afterSubmit(res.id, res, value);
      }
      pending.value = false;
      return res;
    } catch (e) {
      console.error(e);
      setTimeout(() => {
        pending.value = false;
        if (withNotification || withWarning) {
          Notification.warning({ title: t("操作失败，请重试") });
        }
      }, 1000);
      if (shouldThrow) {
        throw e;
      }
    }
  };
  return {
    pending,
    handleSubmit,
  };
};
